import type { OsGroup, OsTotals } from '@/api/accounts';

/**
 * Supplier Outstanding sample data. Supplier payables aren't tracked in the DB
 * yet (no AP ledger), so this page stays on representative sample figures until
 * that ledger exists. Customer OS, Sales Register and Purchase Register are now
 * wired to live backend data (see src/api/accounts.ts).
 */
export const SUPPLIER_OS: OsGroup[] = [
  {
    code: 'VN-204', name: 'Panipat Weaving Mills', terms: '45d',
    d0: 420000, d1: 210000, d2: 0, d3: 0, total: 630000, oldest: '52d',
    invoices: [
      { no: 'GRN/26/0311', date: '02-09-2026', bucket: 'd0', amount: 420000, age: '10d' },
      { no: 'GRN/26/0288', date: '22-07-2026', bucket: 'd1', amount: 210000, age: '52d' },
    ],
  },
  {
    code: 'VN-217', name: 'Sharma Cotton Traders', terms: '30d',
    d0: 184500, d1: 0, d2: 62000, d3: 0, total: 246500, oldest: '69d',
    invoices: [
      { no: 'GRN/26/0330', date: '08-09-2026', bucket: 'd0', amount: 184500, age: '4d' },
      { no: 'GRN/26/0270', date: '05-07-2026', bucket: 'd2', amount: 62000, age: '69d' },
    ],
  },
  {
    code: 'VN-233', name: 'Rugs & Weaves Export House', terms: '60d',
    d0: 305000, d1: 144000, d2: 92000, d3: 0, total: 541000, oldest: '74d',
    invoices: [
      { no: 'GRN/26/0318', date: '04-09-2026', bucket: 'd0', amount: 305000, age: '8d' },
      { no: 'GRN/26/0295', date: '30-07-2026', bucket: 'd1', amount: 144000, age: '44d' },
      { no: 'GRN/26/0281', date: '30-06-2026', bucket: 'd2', amount: 92000, age: '74d' },
    ],
  },
  {
    code: 'VN-241', name: 'Deep Yarn Suppliers, Ludhiana', terms: '30d',
    d0: 0, d1: 0, d2: 0, d3: 188000, total: 188000, oldest: '118d',
    invoices: [
      { no: 'GRN/26/0248', date: '17-05-2026', bucket: 'd3', amount: 188000, age: '118d' },
    ],
  },
  {
    code: 'VN-258', name: 'Textile Print Works', terms: '15d',
    d0: 212400, d1: 64000, d2: 0, d3: 154000, total: 430400, oldest: '131d',
    invoices: [
      { no: 'GRN/26/0324', date: '06-09-2026', bucket: 'd0', amount: 212400, age: '6d' },
      { no: 'GRN/26/0301', date: '25-07-2026', bucket: 'd1', amount: 64000, age: '49d' },
      { no: 'GRN/26/0240', date: '04-05-2026', bucket: 'd3', amount: 154000, age: '131d' },
    ],
  },
];

export const SUPPLIER_OS_TOTALS: OsTotals = { d0: 1121900, d1: 418000, d2: 154000, d3: 342000, total: 2035900 };
